import React from "react";
import { Tooltip } from "react-tooltip";

import { ProfileCardProps } from "@models/components/booking.model";
const TOOLTIP_Z_INDEX = 1000;
const ProfileCard: React.FC<ProfileCardProps> = ({
  cardId,
  cardName,
  disabled = false,
  errorMsg = "",
  handleRemoveCard,
  showCardName = true,
  showRemoveButton = true,
}) => {
  return (
    <div className="text-center align-self-start fg-profile-card-circle-list-item">
      <div className="position-relative d-inline-block">
        <div
          className={`rounded-circle d-flex align-items-center justify-content-center fg-profile-card-circle-list-dp ${errorMsg !== "" ? "error" : ""} ${disabled ? "disabled" : ""}`}
          data-tooltip-id={`fg-profile-card-circle-list-dp-${cardId}`}
          data-tooltip-variant="dark"
          data-tooltip-place="bottom"
          data-tooltip-position-strategy="fixed"
        >
          {cardName.charAt(0).toUpperCase()}
        </div>
        {showRemoveButton && handleRemoveCard && (
          <button
            type="button"
            className="btn btn-sm btn-danger rounded-circle position-absolute p-1  fg-profile-card-circle-remove"
            onClick={() => handleRemoveCard(cardId)}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        )}
      </div>
      <div className="mt-2">
        {showCardName && (
          <>
            <strong
              className="fg-text-primary-main d-block text-truncate fg-profile-card-circle-name"
              data-tooltip-id={`fg-tooltip-${cardId}`}
              data-tooltip-variant="dark"
              data-tooltip-place="bottom"
              data-tooltip-position-strategy="fixed"
            >
              {cardName}
            </strong>
            <Tooltip
              style={{ zIndex: TOOLTIP_Z_INDEX }}
              id={`fg-tooltip-${cardId}`}
              className="fg-tooltip-container"
            >
              {cardName}
            </Tooltip>
          </>
        )}
      </div>
      {errorMsg !== "" && (
        <Tooltip
          style={{ zIndex: TOOLTIP_Z_INDEX }}
          id={`fg-profile-card-circle-list-dp-${cardId}`}
          className="fg-tooltip-container fg-z-index-1"
        >
          {errorMsg}
        </Tooltip>
      )}
    </div>
  );
};

export default ProfileCard;
